/* eslint-disable import/prefer-default-export */
import { useDispatch } from "react-redux";
import ResourceActions from "redux-react/actions/resourceActions";

export const useResourceActions = () => {
	const dispatch = useDispatch();

	const performAction = (data, onSuccess, onFailure) => {
		dispatch(ResourceActions.performAction(data, onSuccess, onFailure));
	};

	const insertResource = (resource, data, onSuccess, onFailure) => {
		dispatch(ResourceActions.insertResource(resource, data, onSuccess, onFailure));
	};

	const deleteResource = (resource, data, onSuccess, onFailure) => {
		dispatch(ResourceActions.deleteResource(resource, data, onSuccess, onFailure));
	};

	const updateResource = (resource, resourceID, data, onSuccess, onFailure) => {
		dispatch(ResourceActions.updateResource(resource, resourceID, data, onSuccess, onFailure));
	};

	return {
		performAction,
		insertResource,
		updateResource,
		deleteResource
	};
};
